/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import { useEffect, useMemo } from 'react'
import noUiSlider from 'nouislider'
import { useLayout } from '../../core'
// import { toAbsoluteUrl } from '../../../helpers'
import { HeaderUserMenu } from '../../../partials'
// import { KTSVG } from '../../../helpers'
// import SettingModalView from 'Presentation/Views/Setting/View'
import { useProfileStore } from 'Store/Profile'
import { useKumopackChat } from 'Hooks/useKumopackChat'
import { generateImageUrl } from 'Utils/generateImageUrl'
import { shallow } from 'zustand/shallow'
import { useChatStore } from 'Store/Chat'

const itemClass = 'ms-1 ms-lg-3'
// const btnClass =
// 	'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px'
const userAvatarClass = 'symbol-35px symbol-md-40px'

const HeaderToolbar = () => {
	const { classes } = useLayout()
	const { profile } = useProfileStore(
		state => ({
			profile: state.userProfile,
		}),
		shallow
	)
	const { chatSupplier } = useKumopackChat()
	const chatUnreadData = useChatStore(state => state.unreadData, shallow)

	const totalUnread = useMemo(() => {
		if (chatUnreadData?.admin && chatUnreadData?.buyer) {
			return (chatUnreadData?.admin ?? []).length + (chatUnreadData?.buyer ?? []).length
		}

		return 0
	}, [chatUnreadData])

	useEffect(() => {
		const rangeSlider = document.querySelector('#kt_toolbar_slider')
		const rangeSliderValueElement = document.querySelector('#kt_toolbar_slider_value')

		if (!rangeSlider || !rangeSliderValueElement) {
			return
		}

		// @ts-ignore
		noUiSlider.create(rangeSlider, {
			start: [5],
			connect: [true, false],
			step: 1,
			format: {
				to: function (value) {
					const val = +value
					return Math.round(val).toString()
				},
				from: function (value) {
					return value
				},
			},
			range: {
				min: [1],
				max: [10],
			},
		})

		// @ts-ignore
		rangeSlider.noUiSlider.on('update', function (values, handle) {
			rangeSliderValueElement.innerHTML = values[handle]
		})

		const handle = rangeSlider.querySelector('.noUi-handle')
		if (handle) {
			handle.setAttribute('tabindex', '0')
		}

		// @ts-ignore
		handle.addEventListener('click', function () {
			// @ts-ignore
			this.focus()
		})

		// @ts-ignore
		handle.addEventListener('keydown', function (event) {
			// @ts-ignore
			const value = Number(rangeSlider.noUiSlider.get())
			// @ts-ignore
			switch (event.which) {
				case 37:
					// @ts-ignore
					rangeSlider.noUiSlider.set(value - 1)
					break
				case 39:
					// @ts-ignore
					rangeSlider.noUiSlider.set(value + 1)
					break
			}
		})
		return () => {
			// @ts-ignore
			rangeSlider.noUiSlider.destroy()
		}
	}, [])

	return (
		<div className="toolbar d-none d-lg-flex align-items-stretch">
			{/* begin::Toolbar container */}
			<div
				className={`${classes.headerContainer.join(
					' '
				)} py-6 py-lg-0 d-flex flex-column flex-lg-row align-items-lg-center justify-content-end`}>
				{/* begin::Favorite Star */}
				<div className={clsx('app-navbar-item', itemClass)}>
					<div
						className={clsx(
							'position-relative',
							'btn btn-icon btn-custom btn-icon-muted btn-active-light w-35px h-35px w-md-40px h-md-40px'
						)}
						// id="kt_drawer_chat_toggle"
					>
						{/* <KTSVG
							path={toAbsoluteUrl('/media/icons/duotune/general/gen003.svg')}
							className="svg-icon-1 m-0"
						/> */}
						{/* <span className="bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink" /> */}
					</div>
				</div>
				{/* end:: Favorite Star */}

				{/* begin:: Chat */}
				<div className={clsx('app-navbar-item', itemClass)}>
					<div
						data-kt-menu-trigger="{default: 'click'}"
						data-kt-menu-attach="parent"
						data-kt-menu-placement="bottom-end"
						className={
							'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-100'
						}
						onClick={chatSupplier}>
						<img src="/media/icons/kumopack/annotation-dots.svg" alt="Kumopack Chat Logo" />

						{totalUnread > 0 && (
							<span className="ms-1 badge badge-danger badge-circle badge-overlap w-20px h-20px animation-blink">
								{totalUnread}
							</span>
						)}
					</div>
				</div>
				{/* end:: Chat */}

				{/* begin::Settings */}
				{/* <div className={clsx('app-navbar-item', itemClass)}>
					<div
						data-kt-menu-trigger="{default: 'click'}"
						data-kt-menu-attach="parent"
						data-kt-menu-placement="bottom-end"
						className={btnClass}>
						<img src="/media/icons/kumopack/settings-01.png" alt="Kumopack Notification Logo" />
					</div>
					<SettingModalView />
				</div> */}
				{/* end::Settings */}

				{/* start::User Menu */}
				<div className={clsx('app-navbar-item', itemClass)}>
					<div
						className={clsx('cursor-pointer symbol', userAvatarClass)}
						data-kt-menu-trigger="{default: 'click'}"
						data-kt-menu-attach="parent"
						data-kt-menu-placement="bottom-end">
						<img
							className="rounded-circle"
							src={
								profile?.pictureProfilePath
									? generateImageUrl(profile?.pictureProfilePath)
									: '/media/icons/kumopack/default-placeholder.png'
							}
							onError={(e: any) => {
								e.target.onerror = null
								e.target.src = '/media/icons/kumopack/default-placeholder.png'
							}}
							alt="Supplier User Profile"
						/>
					</div>
					<HeaderUserMenu />
					{/* end::User Menu */}
				</div>

				{/* end::Toolbar container */}
			</div>
		</div>
	)
}

export { HeaderToolbar }
